import { createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import ApiManager from "../../api/ApiManager";
import { createGenericSlice, DefaultState } from "../createGenericSlice";
import { ProductSliceType } from "./productSlice.types";

export const fetchProduct = createAsyncThunk('product/fetchProduct', (productName: string) => ApiManager.fetchProduct(productName))
export const fetchNewsletter = createAsyncThunk('product/fetchNewsletter', (data: URLSearchParams) => ApiManager.fetchNewsletter(data))

const initialState = {
    id: null,
    code: '',
    name: '',
    url: '',
    unit: '',
    description: '',
    image: {
        main: '',
        gallery: [],
        schema: null
    },
    price: {
        net: null,
        gross: null,
        catalog: {
            net: null,
            gross: null,
        }
    },
    categories: [
        {
            id: null,
            slug: '',
            name: ''
        }
    ],
    params: [{
        name: '',
        value: '',
        unit: '',
    }],
    parts: [],
    accessories: [],
    kits: [],
    recommended: [],
    options: {
        isDiscontinued: null,
        isApproved: null,
        isRecommended: null,
        isBestseller: null,
        isActive: null,
        isHiddenPrice: null,
        isHiddenPriceV2: null,
        isOutOfStock: null
    },
    availabilityInfoRequestSucceed: null
}

const productSliceExtraReducers = <T>(builder: any) => {
    builder
        .addCase(fetchNewsletter.fulfilled, (state: DefaultState, _action: PayloadAction<T>) => {
            (state.data as any).availabilityInfoRequestSucceed = true
        })
        .addCase(fetchNewsletter.rejected, (state: DefaultState, _action: any) => {
            (state.data as any).availabilityInfoRequestSucceed = false
        });
};

const productSlice = createGenericSlice<ProductSliceType>({
    name: 'product',
    initialState: initialState,
    asyncThunk: fetchProduct,
    extraReducers: productSliceExtraReducers
})

export default productSlice.reducer;